import { z } from 'zod'

export const youTubeTopicCategoriesResponseBody = z.array(
    z.object({ name: z.string() })
)

export type YouTubeTopicCategoriesResponseBody = z.infer<
    typeof youTubeTopicCategoriesResponseBody
>
